import React from 'react'
import { motion } from 'framer-motion'
import ChatBot from '../chat/ChatBot'

interface HeroChatBotBoxProps {
  className?: string
}

const HeroChatBotBox: React.FC<HeroChatBotBoxProps> = ({ className = '' }) => {
  return (
    <div className={`w-full max-w-4xl mx-auto ${className}`}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
        className="flex justify-center mb-8"
      >
        <div className="bg-white/20 backdrop-blur-sm rounded-2xl px-6 py-3 shadow-lg border border-white/30">
          <div className="flex items-center space-x-2 text-white font-semibold text-sm">
            <span>AI Tyre Assistant</span>
            <span className="inline-flex h-2 w-2 rounded-full bg-emerald-300" />
            <span className="text-blue-100">Live chat</span>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="max-w-4xl mx-auto"
      >
        <div className="bg-white/80 backdrop-blur-md rounded-3xl shadow-xl p-4 md:p-6 text-left">
          <div className="mb-4 px-2">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Chat With TyreLink Assistant</h2>
            <p className="text-gray-600">
              Ask anything about tyre sizes, nearby fitment centres, pricing, and recommendations.
            </p>
          </div>

          <ChatBot mode="embedded" />
        </div>
      </motion.div>
    </div>
  )
}

export default HeroChatBotBox
